export const isObject = (val: unknown): val is Record<PropertyKey, any> =>
  val !== null && typeof val === "object";

export const isFunction = (val: unknown): val is (...args: any[]) => any =>
  typeof val === "function";

export const isString = (val: unknown): val is string =>
  typeof val === "string";

export const isBoolean = (val: unknown): val is boolean =>
  typeof val === "boolean";

export const isNumber = (val: unknown): val is number =>
  typeof val === "number" && !Number.isNaN(val);

export const isUndef = (val: unknown): val is undefined =>
  typeof val === "undefined";

export const isNonNullable = <T>(val: T): val is NonNullable<T> =>
  val !== undefined && val !== null;

export const isThenable = <T>(val: any): val is PromiseLike<T> =>
  isNonNullable(val) && isFunction(val.then);
